import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggle() {
    this.element.classList.remove("text-truncate")
    this.element.classList.add("text-break")
  }
}
